import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { FastRegistrationForm } from '../../components/FastRegistrationForm';
import { useStores } from '../../hooks';
import Seo from 'components/Seo';

export const FastRegistration = () => {
  const [context, setContext] = useState({});
  const [agreement, setAgreement] = useState('');
  const { api } = useStores();

  useEffect(() => {}, []);

  useEffect(() => {
    api.content
      .getPageApi('lk-reg')
      .then((response) => {
        setContext(response.init_state.object);
      });

    api.content.getPageApi('glavnaya').then((res) => {
      setAgreement(res.init_state.agreement);
    });
  }, []);


  return (
    <main>
      <section className="lk-reg">
        <div className="lk-wrap">
          <Seo seo={context} />

          <FastRegistrationForm agreement={ agreement } />
        </div>
      </section>
    </main>
  );
};
